export default {
  login: {
    form: {
      id: 'Identifiant',
      password: 'Mot de passe',
      button: {
        login: 'Se connecter',
      },
    },
  },
  subscribe: {
    intro:
      'Merci de bien vouloir nous indiquer toutes les informations demandées ci-dessous.' +
      '\n \n' +
      'En fonction des renseignements fournis, votre demande fera l\'objet d\'une validation.' +
      '\n \n' +
      'Si votre accès est accepté, vous recevrez un courrier électronique contenant vos informations de connexion.',
    form: {
      civilite: 'Civilité',
      nom: 'Nom',
      prenoms: 'Prénom',
      mailPrincipal: 'Adresse mail',
      organisme: 'Organisme ou société',
      telephone: 'Numéro de téléphone',
      fonction: 'Fonction',
      adresses: 'Adresse professionnelle',
      commentaire:
        'Précisez ici toute information utile, notamment sur vos motivations concernant cette demande d\'accès',
      button: {
        subscribe: 'S\'inscrire',
        send: 'Demande d\'inscription envoyée.',
      },
    },
    detail: {
      form: {
        origineDemande: 'Origine de la demande',
        pm: {
          add: 'Associer la personne morale',
          sub: 'Sélectionner la personne morale à associer',
          new: 'Créer la personne morale',
        },
        organisme: 'Organisme ou société saisi par le demandeur',
      },
    },
  },
};
